import LoadingStateListItem from './loading_state_list_item.vue';
export default {
    name: 'LoadingStateList',
    components: {
        LoadingStateListItem
    },
    props: {
        listLength: {
            type: Number,
            required: false,
            default: 5
        },
        leftLinesCount: {
            type: Number,
            required: false,
            default: 2
        },
        rightLinesCount: {
            type: Number,
            required: false,
            default: 2
        }
    }
};
